<script setup>
import { computed } from 'vue';
import { useRoute } from 'vue-router';
import Icon from 'next/icon/Icon.vue';

const props = defineProps({
  label: { type: String, required: true },
  icon: { type: String, default: 'i-lucide-external-link' },
  to: { type: Object, required: true },
  appId: { type: [String, Number], required: true },
});

const route = useRoute();

const isActive = computed(() => {
  // Verificar se estamos na rota específica do dashboard app
  const isDashboardAppRoute = route.name === 'external_app_view';
  const isCorrectApp = route.params.appId === String(props.appId);

  return isDashboardAppRoute && isCorrectApp;
});
</script>

<template>
  <li class="grid gap-1 text-sm cursor-pointer select-none">
    <router-link
      :to="to"
      class="flex items-center gap-2 px-2 py-1.5 rounded-lg h-8"
      role="button"
      draggable="false"
      :title="label"
      :class="{
        'text-n-blue-text bg-n-alpha-2 font-medium': isActive,
        'text-n-slate-11 hover:bg-n-alpha-2': !isActive,
      }"
    >
      <div class="relative flex items-center gap-2">
        <Icon :icon="icon" class="size-4" />
      </div>
      <span class="text-sm font-medium leading-5 flex-grow">
        {{ label }}
      </span>
    </router-link>
  </li>
</template>
